// TODO: Wait for official translation
const classificationType = {
  UnidentifiedObject: 'Unidentified Object',
  Structure: 'Structure',
  HumanGathering: 'Human Gathering',
  TemporaryStructure: 'Temporary Structure',
  MechanicalEquipment: 'Mechanical Equipment',
  PotentialLeak: 'Potential Leak',
};

export default {
  class: {
    commercialTruck: 'Camion commercial',
    duplicate: 'Duplicat',
    falsePositive: 'Faux positif',
    humanGathering: 'Rassemblement humain',
    mechanicalEquipment: 'Équipement mécanique',
    movable: 'Object mobile',
    oversizedPassengerVehicle: 'Véhicule de passagers surdimensionné',
    personalProperty: 'Propriété personnelle',
    potentialLeak: 'Fuite potentielle',
    recreationalOffroadVehicle: 'Recreational Offroad Vehicle',
    regularPassengerVehicle: 'Véhicule de passagers régulier',
    structure: 'Structure',
    temporaryStructure: 'Structure temporaire',
    unidentifiedObject: 'Object non identifié',
    unknown: 'Inconnue',
    tileDrainage: 'Drains agricoles',
    exposedPipe: 'Conduits exposés',
  },
  classificationType,
  type: {
    dismissed: 'Rejetée',
    immediate: 'Immédiate',
    investigation: 'Investigation',
    noteAutomatic: 'Note Automatique',
    noteManual: 'Note Manuelle',
    unclassified: 'Non classifiée',
  },
};
